<template lang="pug">
    .container
        .highlight-box(v-if="getConferenceDetails.center")
            h4 {{ getConferenceDetails.event_name }}

            .bottom-info
                .icon-info
                    img(src="@/assets/images/icons/calendar.svg")
                    p
                        span Date:
                        | {{ getConferenceDetails.start_date | formatDate }} - {{ getConferenceDetails.end_date | formatDate }}

                .icon-info
                    img(src="@/assets/images/icons/location.svg")
                    p
                        span Location/Resource:
                        | {{ getConferenceDetails.center.hall_name }}

                .icon-info
                    img(src="@/assets/images/icons/coins.svg")
                    p
                        span Fee:
                        | {{ currency }} {{ fee }}                       

                .icon-info
                    img(src="@/assets/images/icons/user.svg")
                    p
                        span Seats Availability:
                        | {{ availableSeats }}/{{ getConferenceDetails.no_of_public_participants_allowed }}

        .highlight-box.light
            p {{ getConferenceDetails.description }}

        .title-container
            .title-group
                p.step 
                    strong STEP 03: 
                    | Event participation 
                h3 Tell us about your participation


        form.participation-form
            .input-group.spinner-group
                p Number of participants

                NumberSpinner(
                    :value="defaultParticipants"
                    :min="minParticipants"
                    :max="maxParticipants"
                    ref="noParticipants"
                )

            .input-group.spinner-group
                p Number of days participanting

                NumberSpinner(
                    :value="defaultParticipantingDays"
                    :min="minParticipantingDays"
                    :max="maxParticipantingDays"
                    ref="daysParticipanting"
                )

        .button-row
            a.back(href="" @click.prevent="$router.go(-1)") 
                i.fa.fa-angle-left
                | Back

            a.next(href="" :class="{ active: isPassed }" @click.prevent="saveFirstStep") Proceed

</template>

<script>
    import Vue from 'vue';
    import NumberSpinner from '../NumberSpinner';
    import { mapGetters, mapActions } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'Participation',
        data() {
           return {
               isPassed: false,
               defaultParticipants: 1,
               minParticipants: 1,
               maxParticipants: 1,
               participantsSpinner: 1,
               defaultParticipantingDays: 1,
               minParticipantingDays: 1,
               maxParticipantingDays: 1,
               conference_json: {},
               firstStepBookingId: null,
               availableSeats: 0,
               currency: 'USD',
               fee: 0
           } 
        },
        components: {
            NumberSpinner
        },
        computed: mapGetters(['getConferenceDetails', 'firstStepBooking', 'getCurrency', 'currencyDetails']),
        methods: {
            ...mapActions(['getConference', 'postFirstStepBooking', 'addToTotal', 'getRates']),
            ...Vue.filter('formatDate', function(value) {
                if(value) {
                    return moment(String(value)).format('DD MMM YYYY')
                }
            }),
            daysCount() {
                if(this.getConferenceDetails.center) {
                    this.conference_json = this.getConferenceDetails;
                    var conference_info = this.getConferenceDetails;

                    var start_date = moment(String(conference_info.start_date), 'YYYY-MM-DD');
                    var end_date = moment(String(conference_info.end_date), 'YYYY-MM-DD');
                    var diff = end_date.diff(start_date, 'days') + 1; // +1 is for including starting days also

                    this.maxParticipantingDays = diff;

                    // if(conference_info.allow_public == 0) {
                        // this.defaultParticipants = 0;
                        // this.minParticipants = 0;
                        // this.maxParticipants = 0;
                    // } else {
                        this.maxParticipants = conference_info.no_of_public_participants_allowed - conference_info.totalNumberOfConfirmedBookings;

                        this.availableSeats = this.maxParticipants;
                        
                        if(this.availableSeats > 0) {
                            this.isPassed = true;
                        }
                    //     
                    // }                    
                }

            },
            participantsCount() {
                var no_participants = 0;

                if(this.getConferenceDetails.confirmed_bookings) {

                    this.getConferenceDetails.confirmed_bookings.forEach(result => {
                        no_participants += parseInt(result.number_of_participants)
                    });

                    this.availableSeats = this.getConferenceDetails.no_of_public_participants_allowed - no_participants;
                    this.maxParticipants = this.availableSeats;
                    this.participantsSpinner = this.availableSeats;
                }
            },
            saveFirstStep() {
                var bookingData = {
                    "event_category_id": this.conference_json.event_category_id,
                    "event_id": this.conference_json.id,
                    "number_of_participants": this.$refs.noParticipants.numericValue,
                    "number_of_participation_days": this.$refs.daysParticipanting.numericValue 
                };

                var total = (this.$refs.noParticipants.numericValue * this.conference_json.fee_per_person) * this.$refs.daysParticipanting.numericValue;                

                var totalData = {
                    "type": 'participation',
                    "total": total
                }
                
                //add to main total
                this.addToTotal(totalData);

                this.postFirstStepBooking(bookingData).then(() => {
                    this.firstStepBookingId = this.firstStepBooking.results.id;

                    window.localStorage.setItem('firstStepBookingId', this.firstStepBooking.results.id)

                    this.$router.push('/accommodation');
                });

            },
            updateFee() {
                this.currency = 'USD';
                this.fee = this.getConferenceDetails.fee_per_person
            },
            onCurrencyUpdate() {
                if(this.getCurrency == 'LKR') {
                    this.getRates().then(() => {

                        this.currency = this.getCurrency;

                        this.fee = this.getConferenceDetails.fee_per_person * this.currencyDetails.lkr;
                    });
                } else {
                   this.updateFee() 
                }
            },
        },
        created() {
            this.getConference(window.location.pathname.split('/')[2]);
        },
        updated() {
            this.daysCount();
            //this.participantsCount();
        },
        afterUpdate() {
            this.daysCount();
            //this.participantsCount();
        },
        mounted() {
            this.daysCount();
            this.onCurrencyUpdate();
        },
        watch: {
            getCurrency: {
                handler: function() {
                    this.onCurrencyUpdate();
                }
            }
        }        
    };
</script>

<style lang="sass" scoped>
    form 
        margin-bottom: 200px

    .highlight-box
        &:first-child
            margin-bottom: 0

        &.light
            margin-top: 0
</style>



